import { wplToken } from "@atlassiansox/wpl-token";
// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";
import { PropsWithChildren } from "react";

const appSwitcherContainerStyle = css`
    display: flex;
    justify-content: center;

    :hover {
        background: #ebecf0;
        border-radius: ${wplToken("space.300")};
    }

    &.has-text-label {
        border-radius: ${wplToken("space.075")};
    }
`;

export const AppSwitcherContainer = ({ children }: PropsWithChildren) => {
    return (
        <div
            id="global-nav--wac__app-switcher"
            css={appSwitcherContainerStyle}
            className="has-text-label"
            data-testid="global-nav-app-switcher-container"
        >
            {children}
        </div>
    );
};
